module.exports = __webpack_public_path__ + "static/media/cargas-rojo.a614d014.svg";